module.exports = __webpack_public_path__ + "img/banner_body-link_03.3abe2d18.svg";